var AbortionError = require('core/errors/AbortionError');

function abortify(promise /*, state, abortedHandlers*/) {
	var originalThen = promise.then.bind(promise),
		state = arguments[1],
		abortedHandlers = arguments[2];

	if (!state) {
		abortedHandlers = [];

		state = {
			aborted: false
		};
	}

	promise.then = function (fulfilled, rejected, progressed) {
		return abortify(
			originalThen(
				function (value) {
					if (!state.aborted) {
						return typeof fulfilled === 'function' ? fulfilled(value) : value;
					} else {
						throw new AbortionError();
					}
				},
				rejected,
				progressed
			),
			state,
			abortedHandlers
		);
	};

	promise.onAbort = function (cb) {
		abortedHandlers.push(cb);

		return promise;
	};

	promise.abort = function () {
		state.aborted = true;

		abortedHandlers.forEach(function (acb) {
			acb();
		});
	};

	return promise;
}

module.exports = abortify;
